"use strict";


angular.module("core")
.directive("invoiceImageAttachmentAdd", function(
    $compile, $http, InvoiceAttachmentService, FlashBag, semver, MOBILE_APP_VERSION, imageBlobReduce,
    ReadOnlyPermissionService
) {
    return {
        restrict: "A",
        bindToController: {
            invoiceId: "<invoiceImageAttachmentAdd",
            onAdd: "&" // Param: invoiceId
        },
        controllerAs: "invoiceImageAttachmentAddCtrl",
        scope: false,
        link: function($scope, iElement, iAttrs, controller) {
            iElement.off("click");
            iElement.attr("wg-click", "invoiceImageAttachmentAddCtrl.addImage()");
            iElement.on("click", function(){
                controller.addImage();
            });

            controller.hiddenInput = $compile(
                '<input type="file" name="file" accept="image/png, image/jpeg" file-model="newImage" style="display:none"/>'
            )($scope);
            iElement.after(controller.hiddenInput);
        },
        controller: function($scope) {
            var _this = this;
            this.addImage = function() {
                if (MOBILE_APP_VERSION && semver.gte(MOBILE_APP_VERSION, "1.1.0") && window.cordova && window.cordova.platformId === "android") {
                    var cameraOptions = {
                        // https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-camera/#cameracameraoptions--object
                        destinationType: 0, // DATA_URL
                        encodingType: 0, // JPEG
                        correctOrientation: true
                    };
                    navigator.camera.getPicture(
                        function cameraSuccess(imageData) {
                            var byteCharacters = atob(imageData);
                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            var byteArray = new Uint8Array(byteNumbers);
                            var blob = new Blob([byteArray], {type: "image/jpeg"});
                            blob.name = "image.jpg";
                            _this.submitImage(blob);
                        },
                        function cameraError() {
                        },
                        cameraOptions
                    );
                }
                else {
                    this.hiddenInput.trigger('click');
                }
            };

            function addImage(image) {
                var data = new FormData();
                data.append("image", image, image.name);
                InvoiceAttachmentService.addImage(_this.invoiceId, data)
                .then(function onSuccess() {
                    _this.onAdd({invoiceId: _this.invoiceId});
                },
                function onError(response) {
                    ReadOnlyPermissionService.handleResponseError(response);
                    FlashBag.apiError(response);
                })
            }

            this.submitImage = function(newImage) {
                if (newImage) {
                    var reduce = imageBlobReduce();
                    InvoiceAttachmentService.getMaxImageSize().then(
                        function onSuccess(response) {
                            reduce.toBlob(newImage, { max: response.data.maximum_image_attachment_size }).then(
                                function onSuccess(resizedImage) {
                                    resizedImage.name = newImage.name
                                    addImage(resizedImage, newImage);
                                }
                            );
                        },
                        function onError(response) {
                            FlashBag.apiError(response);
                        }
                    );
                }
            }

            $scope.$watch("newImage", this.submitImage);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice-attachment/invoice-image-attachment-add.directive.js
// module id = 509
// module chunks = 0